export default __webpack_public_path__ + "55328316283d5af0cceeb2718f541b86.png";